import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const ShieldIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 15 15" fill={fill}>
            <path
                d="M13.2422 3.04687L7.99219 0.859375C7.82812 0.804687 7.66406 0.777344 7.5 0.777344C7.30859 0.777344 7.14453 0.804687 6.98047 0.859375L1.73047 3.04688C1.23828 3.26562 0.9375 3.73047 0.9375 4.25C0.9375 9.69141 4.05469 13.4375 6.98047 14.668C7.30859 14.8047 7.66406 14.8047 7.99219 14.668C10.3438 13.6836 14.0625 10.3203 14.0625 4.25C14.0625 3.73047 13.7344 3.26562 13.2422 3.04687ZM7.66406 13.8477C7.55469 13.9023 7.41797 13.9023 7.30859 13.8477C4.65625 12.7812 1.8125 9.0625 1.8125 4.25C1.8125 4.08594 1.89453 3.92187 2.05859 3.86719L7.30859 1.67969C7.41797 1.625 7.55469 1.625 7.66406 1.67969L12.9141 3.86719C13.0781 3.92187 13.1875 4.08594 13.1602 4.25C13.1875 9.0625 10.3438 12.7812 7.66406 13.8477ZM7.5 11.9883L7.5 3.48437L3.58984 5.125C3.86328 8.40625 5.69531 11.0039 7.5 11.9883ZM6.625 10.1836C5.61328 9.08984 4.82031 7.50391 4.51953 5.67187L6.625 4.79687L6.625 10.1836Z"
                fill="#7D8286"
            />

        </BaseIcon>
    )
}
